export interface DeeplinkUtils {
  generateDeeplinkHash: () => string
  generateProductLink: (
    linkHash: string,
    productId: string,
    ownerId: string,
  ) => string
  generateUserLink: (linkHash: string, userId: string) => string
}

export class DeeplinkUtilsImplementation implements DeeplinkUtils {
  generateDeeplinkHash = () => {
    const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    let randomString = ''
    for (let i = 0; i < 7; i++) {
      let randomPoz = Math.floor(Math.random() * charSet.length)
      randomString += charSet.substring(randomPoz, randomPoz + 1)
    }
    return randomString
  }

  generateProductLink = (
    linkHash: string,
    productId: string,
    ownerId: string,
  ) =>
    `https://vooxee.com/${productId}?action=advert&id=${productId}&dynamic_link_refer_hash=${linkHash}&user=${ownerId}`

  generateUserLink = (linkHash: string, userId: string) =>
    `https://vooxee.com/user/${userId}?action=profile&id=${userId}&dynamic_link_refer_hash=${linkHash}`
}
